import { Button, CharField, ImageField, NumberField, Pagination } from "@inmagik/magik-ui"
import { useFormikContext } from "formik"
import { Col, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "react-bootstrap"
import type { FiltersBase, Media, RecordMedia } from "../../types"
import { useCreateMedia, useMediaList } from "../../hooks/media"
import { useMemo } from "react"
import { useQsFilters } from "../../hooks/filters"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { PAGE_SIZE } from "../../constants"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "name",
  } as FiltersBase)

function ImageSelector({}: {}) {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)
  const { values, setFieldValue } = useFormikContext<RecordMedia>()
  const { data } = useMediaList({
    search: filters.search,
    page: String(filters.page),
  })

  const numPages = useMemo(() => {
    if (!data) {
      return 1
    }
    return Math.ceil(data.count / PAGE_SIZE)
  }, [data])

  return (
    <div>
      <div style={{ maxHeight: 300, overflowY: "auto", position: "relative", minHeight: 500 }}>
        <div style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 2, paddingBottom: 8 }}>
          <CharField
            label="Cerca Immagine"
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: "100%",
            }}
            value={uiFilters.search || ""}
            onChange={(value) => {
              setFilters({ ...filters, search: value, page: 1 })
            }}
          />
        </div>
        <Table hover responsive className="mt-3">
          <thead style={{ position: "sticky", top: 0, backgroundColor: "white", zIndex: 1 }}>
            <tr>
              <th>Seleziona</th>
              <th>Immagine</th>
              <th>Nome immagine</th>
            </tr>
          </thead>
          <tbody>
            {data?.results?.map((media) => (
              <tr key={media.id}>
                <td>
                  <input
                    disabled={!media.id}
                    type="checkbox"
                    checked={values.media === media.id}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setFieldValue("media", media.id)
                      } else {
                        setFieldValue("media", undefined)
                      }
                    }}
                  />
                </td>
                <td>
                  {media?.media_file && (
                    <img src={media.media_file as string} alt={media.title} style={{ width: 100, height: "auto" }} />
                  )}
                </td>
                <td>{media.media_file ? media.media_file.toString().split("/").pop() : "-"}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="d-flex align-items-center justify-content-center">
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </div>
    </div>
  )
}

export default function MediaDocumentForm({ col = 8 }: { col?: number; id: number | undefined }) {
  const { values, setFieldValue } = useFormikContext<RecordMedia & Media>()

  const { data: media } = useMediaList({})

  const createMediaDocument = useCreateMedia()
  const [stateImageSelector, actionsImageSelector] = useModalTrigger()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <div>
        Immagine selezionata:
        {values.media ? (
          <div className="mt-2">
            <img
              src={
                media?.results?.find((m) => m.id === values.media)?.media_file
                  ? String(media?.results?.find((m) => m.id === values.media)?.media_file)
                  : ""
              }
              alt={media?.results?.find((m) => m.id === values.media)?.title || "Selected Image"}
              style={{ width: 200, height: "auto" }}
            />
          </div>
        ) : (
          <div className="mt-2">Nessuna immagine selezionata</div>
        )}
        <Button
          className="mt-3"
          title="Seleziona Immagine"
          size="md"
          leadingIcon="image"
          onClick={() => {
            actionsImageSelector.open()
          }}
        />
      </div>

      <div>
        <ImageField
          label="Carica nuova immagine"
          layout="horizontal"
          value={values.media_file}
          onChange={async (value) => {
            if (!value) {
              return
            }
            await createMediaDocument
              .mutateAsync({
                media_file: value,
              })
              .then((media) => {
                setFieldValue("media", media.id)
                return media
              })
          }}
        />
      </div>

      <NumberField label="Ordine" layout="horizontal" value={values.order} />
      <Modal show={stateImageSelector.isOpen} onHide={actionsImageSelector.close} size="lg" centered>
        <ModalHeader closeButton>
          <Modal.Title>Seleziona Immagine</Modal.Title>
        </ModalHeader>
        <ModalBody>
          <ImageSelector />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <div id="note-block-modal"></div>
          <div className="d-flex gap-2">
            <Button
              type="button"
              variant="secondary"
              onClick={actionsImageSelector.close}
              title="Chiudi"
              className="text-white"
              size="md"
            />
            <Button type="button" variant="primary" onClick={actionsImageSelector.close} title="Seleziona" size="md" />
          </div>
        </ModalFooter>
      </Modal>
    </Col>
  )
}
